import React, { useEffect, useState } from 'react';
import '../styles/Hero.scss';
import hero from '../assets/hero2.PNG';
import h1 from '../assets/h1.png';
import h2 from '../assets/h2.png';

import waterfall from '../assets/video/waterfall.mp4';
import sparrow from '../assets/video/sparrow.mp4';
import butterfly from '../assets/video/butterfly.mp4';
import img2 from '../assets/gallery/2.jpeg';
import img4 from '../assets/gallery/4.jpg';

export default function Hero() {
    const [activeIndex, setActiveIndex] = useState(0);

    const slides = [
        
        { type: 'image', src: img2 },
        { type: 'image', src: h2 },
        { type: 'video', src: waterfall },
        { type: 'image', src: h1 },
        { type: 'video', src: butterfly },
        { type: 'image', src: img4 },
        { type: 'video', src: sparrow },
    ];

    useEffect(() => {
        const interval = setInterval(() => {
            setActiveIndex((prev) => (prev + 1) % slides.length);
        }, 5000); // change every 5s
        return () => clearInterval(interval);
    }, [slides.length]);

    useEffect(() => {
        const onScroll = () => {
            const hero = document.querySelector('.hero-visuals');
            if (!hero) return;
            const scrolled = window.scrollY;
            hero.style.transform = `translateY(${scrolled * 0.12}px)`; // gentle parallax
        };
        window.addEventListener('scroll', onScroll);
        return () => window.removeEventListener('scroll', onScroll);
    }, []);

    return (
        <section className="hero" id="hero">
            <div className="hero-inner">
                {/* Left Content */}
                <div className="hero-content">
                    <h1>
                        Own a Piece of Paradise at <span className="accent">Lonavalley</span>
                        <small>@Lonavala Annex</small>
                    </h1>
                    <p className="sub">
                        Premium Resort NA Plots amidst nature near Lonavala
                    </p>

                    <div className="hero-ctas">
                        <a className="btn primary" href="#contact">Get Brochure</a>
                        <a className="btn ghost" href="#pricing">Schedule a Visit</a>
                    </div>

                    <div className="hero-quick">
                        <div>
                            <strong>10,000</strong>
                            <span>sq.ft. plots</span>
                        </div>
                        <div>
                            <strong>₹550</strong>
                            <span>/sq.ft Pre Launch Price</span>
                        </div>
                        <div>
                            <strong>4.5</strong>
                            <span>Acre Wellness Resort</span>
                        </div>
                    </div>
                </div>

                {/* Right-side Visual Storytelling */}
                <div className="hero-visuals">
                    {slides.map((slide, idx) => (
                        <div
                            key={idx}
                            className={`visual-slide ${idx === activeIndex ? 'active' : ''}`}
                        >
                            {slide.type === 'video' ? (
                                <video autoPlay muted loop playsInline>
                                    <source src={slide.src} type="video/mp4" />
                                </video>
                            ) : (
                                <img src={slide.src} alt={`Slide ${idx}`} />
                            )}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
}
